import React from 'react';
import { Link } from 'react-router-dom';

const TravelCard = ({ title, price, duration, groupType, save, oldPrice, date, image }) => {
  const themeColor = '#2A6559'; // Primary theme color
  const accentColor = '#E58A4D'; // Accent color

  return (
    <Link to="/detail" className="block group">
      <div className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100">
        {/* Image Section */}
        <div className="relative h-48">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover"
          />
          
          {/* Image Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          
          {/* Top Badges */}
          <div className="absolute top-3 left-3 right-3 flex justify-between">
            <span className="px-3 py-1.5 bg-white text-sm font-medium rounded-full shadow-sm" style={{ color: themeColor }}>
              {groupType}
            </span>
            
            {save && (
              <div className="px-3 py-1.5 bg-red-500 text-white text-sm font-medium rounded-full shadow-sm">
                Save {save}
              </div>
            )}
          </div>
        </div>

        {/* Content Section */}
        <div className="p-5">
          {/* Title */}
          <h3 className="text-lg font-semibold text-gray-800 mb-2 leading-tight line-clamp-2">
            {title}
          </h3>

          {/* Details Grid */}
          {/* <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="flex items-center text-gray-600">
              <svg 
                className="w-5 h-5 mr-2" 
                fill="none" 
                stroke={themeColor} 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-sm">{duration}</span>
            </div>

            <div className="flex items-center text-gray-600">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke={themeColor}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 0v4M3 11h18M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span className="text-sm">{date}</span>
            </div>
          </div> */}

          {/* Price Section */}
          <div className="flex justify-between items-center mb-4">
            <div>
              {oldPrice && (
                <p className="text-sm text-gray-400 line-through">{oldPrice}</p>
              )}
              <p className="text-xl font-bold" style={{ color: themeColor }}>
                {price}
                <span className="text-sm font-normal text-gray-600 ml-1">/person</span>
              </p>
            </div>

            {/* Rating */}
            <div className="flex items-center">
              {[1, 2, 3, 4, 5].map((star) => (
                <svg
                  key={star}
                  className="w-4 h-4 text-amber-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
          </div>

          {/* CTA Button */}
          <button
            className="w-full py-2.5 rounded-lg font-medium text-white transition-colors duration-200"
            style={{ backgroundColor: accentColor }}
          >
            View Details
          </button>
        </div>
      </div>
    </Link>
  );
};

export default TravelCard;